import img1 from "../ExploreOurProduct/Images/dog.png";
import img2 from "../ExploreOurProduct/Images/camera.png";
import img3 from "../ExploreOurProduct/Images/laptop.png";
import img4 from "../ExploreOurProduct/Images/makeup.png";
import img5 from "../ExploreOurProduct/Images/toyCar.png";
import img6 from "../ExploreOurProduct/Images/soccer.png";
import img7 from "../ExploreOurProduct/Images/controller.png";
import img8 from "../ExploreOurProduct/Images/jacket.png";
export const ExploreData=[
    {
        id:  18,
        img:img1 ,
        title:"Breed Dry Dog Food",
        currentPrice: 100,
        starRate:3 ,
        reviews: 35,
        color:"" ,
        new:null,
    }, {
        id:  19,
        img: img2,
        title:"CANON EOS DSLR Camera",
        categoryItem:"electronic",
        currentPrice:360 ,
        starRate: 4 ,
        reviews: 95,
        color:"" ,
        new:null,
    }, {
        id:  20,
        img: img3,
        title:"ASUS FHD Gaming Laptop",
        categoryItem:"gaming",
        currentPrice: 700 ,
        starRate: 5,
        reviews: 325,
        color: "",
        new:null,
    }, {
        id:  21,
        img: img4,
        title:"Curology Product Set ",
        currentPrice: 500 ,
        starRate: 4,
        reviews:145 ,
        color:'' ,
        new:null,
    }, {
        id:  22,
        img: img5,
        title:"Kids Electric Car",
        categoryItem:"electronic",
        currentPrice: 1160 ,
        starRate:5 ,
        reviews:65 ,
        color: "red",
        new:"NEW",
    }, {
        id:  23,
        img: img6,
        title:"Jr. Zoom Soccer Cleats",
        currentPrice: 960 ,
        starRate: 5,
        reviews:35 ,
        color: "yellow",
        new:null,
    }, {
        id:  24,
        img: img7,
        title:"GP11 Shooter USB Gamepad",
        categoryItem:"electronic",
        currentPrice: 660 ,
        starRate:4.5 ,
        reviews:55 ,
        color: "black",
        new:"NEW",
    }, {
        id:  25,
        img: img8,
        title:"Quilted Satin Jacket",
        currentPrice: 660 ,
        starRate: 4.5,
        reviews:55 ,
        color: "gray" ,
        new:null,
    }, {
        id:  26,
        img: img5,
        title:"Kids Electric Car",
        categoryItem:"electronic",
        currentPrice: 1160 ,
        starRate:5 ,
        reviews:65 ,
        color: "red",
        new:"NEW",
    }, {
        id:  27,
        img: img3,
        title:"ASUS FHD Gaming Laptop",
        categoryItem:"gaming",
        currentPrice: 700 ,
        starRate: 5,
        reviews: 325,
        color: "",
        new:null,
    },
]